import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <section className="flex-1 flex items-center justify-center bg-bgn-black py-24">
        <div className="max-w-2xl mx-auto px-4 lg:px-8 text-center">
          <div className="text-8xl lg:text-9xl font-bold text-bgn-gold mb-4">404</div>
          <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6">
            Page Not Found
          </h1>
          <p className="text-lg text-bgn-grey leading-relaxed mb-10">
            This page doesn't exist or may have been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="border border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-bgn-black transition-colors duration-200"
            >
              Go Back
            </button>
            <button
              onClick={() => navigate('/')}
              className="bg-bgn-gold text-bgn-black px-8 py-4 rounded-full font-bold text-lg hover:bg-white transition-colors duration-200"
            >
              Back to Home
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
